import {
  ApolloProvider,
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  ApolloLink,
  concat,
} from '@apollo/client'
import TokenContext from '../Contexts/TokenContext'
import { useContext } from 'react'
import GridProvider from '../../genericGrid/GridProvider'
import MutationProvider from '../../genericSidescreens/MutationProvider'
const ApolloInjector = ({ children }) => {
  const apolloUrl = process.env.REACT_APP_APOLLO_URL
  const token = useContext(TokenContext);

  if (!apolloUrl) {
    return children
  }
  const httpLink = createHttpLink({
    uri: apolloUrl
  })
  const cache = new InMemoryCache()
  let link
  const authMiddleware = new ApolloLink((operation, forward) => {
    //add the authorization to the headers

    operation.setContext(({ headers = {} }) => ({
      headers: {
        ...headers,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token.current}`
      }
    }))

    return forward(operation)
  })
  link = concat(authMiddleware, httpLink)

  const apolloClient = new ApolloClient({
    cache: cache,
    link: link,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-only',
        // pollInterval: 10000,
        notifyOnNetworkStatusChange: true,
      }
    }
  })

  if (!token) return <>No token...</>
  const usesGrid = process.env.REACT_APP_USES_GRID == "true"
  const usesDefaultSideScreens = process.env.REACT_APP_USES_DEFAULT_SIDESCREENS == "true";


  if (!usesGrid) {    
    return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
  }
  if (usesDefaultSideScreens && usesGrid) {
    return (
      <ApolloProvider client={apolloClient}>
        <GridProvider>
          <MutationProvider>{children}</MutationProvider>
        </GridProvider>
      </ApolloProvider>
    )
  }
  if (usesDefaultSideScreens) {
    return (
      <ApolloProvider client={apolloClient}>
        <MutationProvider>{children}</MutationProvider>{children}
      </ApolloProvider>)

  }
  return (
    <ApolloProvider client={apolloClient}>
      <GridProvider>{children}</GridProvider>
    </ApolloProvider>
  )
}
export default ApolloInjector
